import { Link } from "react-router-dom";

import Logo from "./Logo";

const Footer = () => {
    return (
        <footer className="py-20 bg-black text-white">
            <div className="container">
                <div className="flex justify-between align-top mb-16">
                    <Link to='authorization' className="font-semibold">
                        Войти в аккаунт
                    </Link>
                    <div className="flex">
                        <div className="flex flex-col gap-5 mr-24">
                            <div className="font-semibold h-fit">Служба поддержки</div>
                            <Link to='tel:+123456789'>+123456789</Link>
                            <Link to='tel:+123456789'>+123456789</Link>
                        </div>
                        <div className="flex flex-col gap-5">
                            <div className="font-semibold h-fit">Адрес</div>
                            <p className="h-fit">
                                ул. Название 44<br/>
                                г. Алматы, Казахстан 00000
                            </p>
                        </div>
                    </div>
                </div>
                <Logo className='block w-28 h-12' />
                <div className='flex justify-between align-bottom'>
                    <div className="text-gray-300"> 
                        © 2Stay - All rights reserved 2023 - 2024
                    </div>
                    <div className="flex">
                        <Link to='#' target='_blank' className="mr-28">
                            <img src='/icons/google-play-badge.svg' alt='google play badge' width='162' height='48' />
                        </Link>
                        <div className="grid grid-cols-3 gap-8 max-w-[202px]">
                            <Link to='#' target='_blank'>
                                <img src="/icons/facebook.svg" alt="facebook" />
                            </Link>
                            <Link to='#' target='_blank'>
                                <img src="/icons/instagram.svg" alt="facebook" />
                            </Link>
                            <Link to='#' target='_blank'>
                                <img src="/icons/vk.svg" alt="facebook" />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
};

export default Footer;